import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MissionsService } from 'src/app/providers/services/missions.service';
import { ReactorsService } from 'src/app/providers/services/reactors.service';
import { Mission } from 'src/app/storage/models/mission.model';
import { Reactor } from 'src/app/storage/models/reactor.model';
import { CONSTANTS } from 'src/app/constants';
import { NavigationService } from 'src/app/providers/services/navigation.service';

@Component({
    selector: 'app-mission-info',
    templateUrl: './mission-info.component.html',
    styleUrls: ['./mission-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MissionInfoComponent implements OnInit, OnDestroy {

  mission: Mission;
  missionSubscription: Subscription;

  reactors: Reactor[];

  constructor(
    private missionsService: MissionsService,
    private reactorsService: ReactorsService,
    private navigationService: NavigationService
  ) { }

  async ngOnInit(): Promise<void> {
    this.missionSubscription = this.missionsService.selectedMission$.subscribe(async (mission: Mission) => {
      this.mission = mission;
      this.reactors = await this.reactorsService.getMissionReactors(this.mission);
    });
  }

  async backToMissionConfig(): Promise<void> {
    await this.navigationService.navigateFromHome(CONSTANTS.ROUTES.MISSION_CONFIG);
  }

  ngOnDestroy(): void {
    if (this.missionSubscription) { this.missionSubscription.unsubscribe(); }
  }

}
